import { css } from 'linaria';

export const image = css`
  width: 40px;
  height: 40px;
  /* for image alt text */
  overflow: hidden;
  border-radius: 20px;
`;

export const descriptionStyle = css`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const mobileProduct = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const tabletProduct = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const leftSide = css`
  display: flex;
  min-width: 0;

  & > * + * {
    margin-left: 12px;
  }
`;

export const flexVerticalCenter = css`
  display: flex;
  align-items: center;
`;

export const textWrapper = css`
  min-width: 0;
`;

export const mediumPlusScreenProduct = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const mediumPlusScreenProductItem = css`
  margin-left: var(--space-100);
`;

export const mediumPlusScreenProductButton = css`
  min-width: 40px;
  height: 40px;
  margin-left: var(--space-100);
  padding: var(--space-35) !important;

  button > span > div {
    margin-right: 0;
  }
`;

export const mediumPlusScreenProductOutOfStock = css`
  width: 138px;
`;
